<template>
    <transition name="slide-left">
        <div class="home">
            <div class="logo">
                <img src="@/assets/imgs/vesoft_logo_branca.png" alt="Logo vex" />
            </div>

            <div class="div-login">
                <form>
                    <md-field>
                        <label>Token [Código de acesso]</label>
                        <md-input
                            class="input"
                            :value="enterprise"
                            @input.native="enterprise = $event.target.value.toUpperCase()"
                            type="text"
                            id="enterprise"
                            :disabled="!canLogin"
                        ></md-input>
                    </md-field>
                    <md-field>
                        <label>E-mail</label>
                        <md-input
                            class="input"
                            v-model="email"
                            type="email"
                            id="email"
                            :disabled="!canLogin"
                        ></md-input>
                    </md-field>
                    <md-field>
                        <label>Senha</label>
                        <md-input
                            class="input"
                            v-model="password"
                            type="password"
                            id="password"
                            :disabled="!canLogin"
                        ></md-input>
                    </md-field>
                    <!-- <div
                        class="g-recaptcha"
                        data-sitekey="6Ld2MxMpAAAAAFPrKzSYOlm9tlzY1UK3GxcF0tsp"
                        data-size="invisible">
                    </div>
                    <b-button
                        class="mt-4 btn btn-success entrarButton"
                        type="submit"
                        id="authButton"
                        @click="validarCaptcha"
                        :disabled="!canLogin"
                    >
                        Entrar
                    </b-button> -->
                    <b-button
                        class="mt-4 btn btn-success entrarButton"
                        type="submit"
                        id="authButton"
                        @click="autenticarUsuario"
                        :disabled="!canLogin"
                    >
                        Entrar
                    </b-button>
                </form>

                <div class="status">
                    <span
                        class="saveDataProgress"
                        :style="{
                            width: `${$store.getters.downloadAllVexDataStatus.percentage}%`,
                        }"
                    ></span>
                    <span class="textStatus">
                        {{ $store.getters.downloadAllVexDataStatus.status }}
                    </span>
                </div>
            </div>

            <div class="enroll">
                <a href="https://esqueciminhasenha.vexsoft.com.br/#/"
                    >Esqueci minha senha e/ou token</a
                >
                <a href="https://cadastro.vexsoft.com.br/#/">Ainda não possuo cadastro</a>
            </div>

            <update-button ref="updateButton"
                @startSearch="(event) => {
                        const {blocking} = event
                        canLogin = blocking ? false : true
                    }"
                @endSearch="(event) => {
                    const {updateFound} = event
                    if(updateFound) {
                        canLogin = false
                    } else {
                        canLogin = true
                    }
                }"
                @updateFound="() => {
                    canLogin = false
                }"
                @endUpdate="() => {
                    canLogin = true
                }"
            ></update-button>

            <FooterComponent />
        </div>
    </transition>
</template>

<script>
import { BButton } from "bootstrap-vue";
import Vue from "vue";
import MdButton from "vue-material/dist/components/MdButton";
import MdField from "vue-material/dist/components/MdField";
import "vue-material/dist/theme/default.css";
import "vue-material/dist/vue-material.min.css";

import FooterComponent from "@/components/Footer.vue";
import UpdateButton from "@/components/UpdateButton.vue";
import downloadAllVexData from "@/controller/downloadAllVexData";
import autenticarNoVex from "@/services/vex/login";
import existAnotherEnterpriseInspectionNotTransmited from "@/services/vex/vistoriasInfo";
import Swal from "sweetalert2";

Vue.use(MdField);
Vue.use(MdButton);

export default {
    name: "Login",
    components: {
        "update-button": UpdateButton,
        FooterComponent,
        BButton
    },
    data: function () {
        return {
            enterprise: "",
            email: null,
            password: null,
            canLogin: true,
        };
    },
    created() {
        let status = {
            status: undefined,
            percentage: 0,
        };
        this.$store.commit("setDownloadAllVexDataStatus", status);
    },
    methods: {
        // validarCaptcha(event){
        //     try {
        //         event.preventDefault();
        //         const vm = this;
        //         // eslint-disable-next-line
        //         grecaptcha.ready(function () {
        //             // eslint-disable-next-line
        //             grecaptcha.execute('6Ld2MxMpAAAAAFPrKzSYOlm9tlzY1UK3GxcF0tsp', { action: 'submit' })
        //                 .then(async function (token) {
        //                     vm.autenticarUsuario(event, token);
        //                 });
        //         });
        //     } catch (error) {
        //         console.error(error);
        //     }
        // },
        autenticarUsuario: async function (event/*, tokenCaptcha*/) {
            document.getElementById("authButton").disabled = true;

            let doExistAnotherEnterpriseInspectionNotTransmited =
                await existAnotherEnterpriseInspectionNotTransmited(this.enterprise);

            if (!doExistAnotherEnterpriseInspectionNotTransmited) {
                let updateFound = null;
                try {
                    updateFound = await this.$refs.updateButton.lookForUpdates({blocking: true});
                } catch (error) {
                    console.error(error);
                    updateFound = false;
                }

                if(!updateFound){
                    try {
                        const userInfo = await autenticarNoVex(this.enterprise, this.email, this.password/*, tokenCaptcha*/);
                        const saveUserInfo = true;
                        downloadAllVexData(this.enterprise, userInfo, saveUserInfo).then(
                            () => this.$router.push({ path: "/home" })
                        );
                    } catch (error) {
                        let message = error?.error_description || error?.error_msg || error?.error || error?.message || error;
                        Swal.fire({
                            text: message,
                            confirmButtonColor: "#3085d6",
                            confirmButtonText: "Ok",
                        });
                        document.getElementById("authButton").disabled = false;
                    }
                }
            } else {
                Swal.fire({
                    text: `Existe outro token com vistorias pendentes de envio. Faça login com ele e transmita as vistorias pendentes antes de fazer login com o ${this.enterprise}`,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Ok",
                });
                document.getElementById("authButton").disabled = false;
            }
        },
    },
};
</script>

<style scoped>
.slide-left-enter-active, .slide-left-leave-active {
    transition: transform .3s ease;
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
}

.slide-left-enter-active {
    transform: translate(100%, 0);
}

.slide-left-leave-active {
    transform: translate(-100%, 0);
}

.textStatus {
    margin-top: -60px;
    font-weight: bold;
}

.entrarButton {
    padding: 5px;
}

.entrar {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.status {
    display: flex;
    flex-direction: column;
}

.saveDataProgress {
    border-radius: 5px;
    background-color: rgb(255, 115, 0);
    margin-top: -34px;
    height: 34px;
    /* transform: translate3d(100%, 0px, 0px); */
}

.home {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    background-image: url("@/assets/imgs/fundo_login_3.png");
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: 10px;
    padding-bottom: 60px;
}

.logo {
    margin-top: 10px;
    margin-bottom: 30px;
}

.logo img {
    max-width: 200px;
    width: auto;
    height: auto;
}

.div-login {
    width: 70%;
}

.md-field.md-theme-default label {
    color: white;
}

button.mt-4.btn.btn-success {
    width: 100%;
    background-color: orange;
    border: transparent;
}

.input:-webkit-autofill,
.input:-webkit-autofill:hover,
.input:-webkit-autofill:focus,
.input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
}

button.mt-4.btn.btn-success {
    width: 100%;
    background-color: orange;
    border: transparent;
}

.enroll {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
}

.enroll a {
    margin: 10px 0px;
    color: white;
}
</style>
